import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../AxiosConfig';
import './Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState(null);
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const response = await axios.post("/api/auth/login", { email, password });
      const user = response.data;
  
      if (user.is_admin) {
        navigate('/admin', { state: { fromLogin: true } });
      } else {
        const orgCheckResponse = await axios.get("/api/organizations/check_user_org");
        if (orgCheckResponse.data.hasOrg) {
          navigate('/myOrg');  
        } else {
          navigate('/createEditOrg');       
        }
      }
    } catch (error) {
      setErrorMessage(error.response?.data?.error || 'Login failed');
    }
  };

  return (
    <div className="login-container">
      <div className="login-left">
        <div className="login-form-container">
          <h2 className="login-title">Welcome to the MetaPortal!</h2>
          {errorMessage && <p className="error-message">{errorMessage}</p>}
          <form>
            <label htmlFor="email">Email</label>
            <input type="email" id="email" placeholder="Enter your email" value={email} onChange={(e) => setEmail(e.target.value)} required />

            <label htmlFor="password">Password</label>
            <input type="password" id="password" placeholder="Enter your password" value={password} onChange={(e) => setPassword(e.target.value)} required />

            <button type="button" className="login-button" onClick={handleLogin}>
              Log in
            </button>
          </form>
          <div className="login-links">
            <span onClick={() => navigate('/register')}>Register</span>
            <span onClick={() => navigate('/forgot-password')}>Forgot Password</span>
          </div>
        </div>
      </div>
      <div className="login-right">
        <img src="/CSR_Logo.png" alt="CSR Logo" className="login-logo" />
      </div>
    </div>
  );
};

export default Login;
